import React from 'react'

const IconCenterPlaceholder = ({
  className = '',
  strokeWidth = '1'
}: {
  className?: string
  strokeWidth?: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.302734"
        width="32"
        height="32"
        rx="6"
      />
      <g clipPath="url(#clip0_452_4419)">
        <path
          d="M23.8952 21.8557L19.8952 13.8557C19.7422 13.5507 19.4452 13.3437 19.1062 13.3087C18.7682 13.2697 18.4332 13.4127 18.2202 13.6777L14.7922 17.9617L12.5552 16.4707C12.3272 16.3197 12.0462 16.2667 11.7812 16.3267C11.5142 16.3867 11.2832 16.5537 11.1432 16.7877L8.14319 21.7877C7.95719 22.0967 7.95319 22.4807 8.13019 22.7957C8.30719 23.1097 8.64019 23.3027 9.00019 23.3027H23.0002C23.3472 23.3027 23.6682 23.1227 23.8512 22.8277C24.0342 22.5327 24.0492 22.1647 23.8952 21.8557Z"
          className="fill-gray-700 group-active:fill-primary-400 group-hover:fill-primary-400 group-aria-selected:fill-primary-400"
        />
        <path
          d="M14 13.3027C15.1046 13.3027 16 12.4073 16 11.3027C16 10.1982 15.1046 9.30273 14 9.30273C12.8954 9.30273 12 10.1982 12 11.3027C12 12.4073 12.8954 13.3027 14 13.3027Z"
          className="fill-gray-700 group-active:fill-primary-400 group-hover:fill-primary-400 group-aria-selected:fill-primary-400"
        />
      </g>
      <defs>
        <clipPath id="clip0_452_4419">
          <rect
            width="16"
            height="16"
            className={`fill-gray-300 ${className || ''}`}
            transform="translate(8 8.30273)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconCenterPlaceholder
